import { Document, Page, pdf } from "@react-pdf/renderer";
import { useState } from "react";
import { GrDocumentPdf } from "react-icons/gr";
import PdfFooter from "../../containers/User/PortInformation/pdfFooter";
import PdfHeader from "../../containers/User/PortInformation/pdfHeader";
import CargoPdf from "../Calculator/CargoPdf";
import CommonPdfPreviewModal from "./CommonPdfPreviewModal";

const DowloadPDF = (props) => {
  const { pdfDocument, pdfName, portOperations, query, onDownloadPdf = () => { } } = props;
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const downloadFile = (filename, url) => {
    let element = document.createElement("a");
    element.href = url;
    element.setAttribute("download", filename);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  };

  const pdfdetails = (pdfSaveId) => {
    return <CargoPdf portOperations={portOperations} query={query} pdfSaveId={pdfSaveId} />;
  };

  const downloadPDF = async () => {
    const data = await onDownloadPdf();
    if (data?.data?._id) {
      const details = await pdfdetails(data?.data?._id);
      const pdfBlob = await pdf(
        <Document>
          <Page size="A4" orientation="landscape" style={{ paddingBottom: 35 }}>
            <PdfHeader />
            {details}
            <PdfFooter />
          </Page>
        </Document>
      ).toBlob();
      const url = window.URL.createObjectURL(
        new Blob([pdfBlob], { type: "application/pdf" })
      );
      downloadFile(pdfName, url);
    }
  };

  const documentToPreview = (
    <Document>
      <Page size="A4" orientation="landscape" style={{ paddingBottom: 35 }}>
        <PdfHeader />
        {pdfdetails("")}
        <PdfFooter />
      </Page>
    </Document>
  );

  return (
    <>
      <button
        onClick={handleOpen}
        className="flex items-center gap-1.5 px-2.5 py-1 h-[26px] text-[11px] font-medium text-slate-900 bg-white hover:bg-slate-50 border border-slate-300 rounded-none shadow-2xs transition-colors cursor-pointer"
      >
        <GrDocumentPdf size={13} className="text-[#313C4C]" />
        <span>Download PDF</span>
      </button>

      <CommonPdfPreviewModal
        open={open}
        onClose={handleClose}
        title="PDF Preview"
        subtitle="A4 Landscape Report • Smart Sea Freight"
        document={documentToPreview}
        onDownload={downloadPDF}
        downloadFileName={pdfName}
      />
    </>
  );
};

export default DowloadPDF;
